/**
 * 차량 도막 측정 맵 - 세단 상면도
 * Props: data, width
 */
import React from 'react';

var getPaintColor = function(v) {
  if (!v) return '#D3D1C7';
  var n = typeof v === 'string' ? parseInt(v, 10) : v;
  if (isNaN(n)) return '#D3D1C7';
  if (n < 150) return '#1D9E75';
  if (n < 250) return '#EF9F27';
  return '#E24B4A';
};

var getPaintBg = function(v) {
  if (!v) return '#f5f5f2';
  var n = typeof v === 'string' ? parseInt(v, 10) : v;
  if (isNaN(n)) return '#f5f5f2';
  if (n < 150) return '#E1F5EE';
  if (n < 250) return '#FAEEDA';
  return '#FCEBEB';
};

export default function CarPaintMap({ data = {}, width = 280 }) {
  var getValue = function(key) {
    var map = {
      hood: ['hood', 'paint_hood'],
      roof: ['roof', 'paint_roof'],
      fenderL: ['fenderL', 'paint_fender_l'],
      fenderR: ['fenderR', 'paint_fender_r'],
      doorFL: ['doorFL', 'paint_door_fl'],
      doorFR: ['doorFR', 'paint_door_fr'],
      doorRL: ['doorRL', 'paint_door_rl'],
      doorRR: ['doorRR', 'paint_door_rr'],
      trunk: ['trunk', 'paint_trunk'],
      quarterL: ['quarterL', 'paint_quarter_l'],
      quarterR: ['quarterR', 'paint_quarter_r'],
    };
    var keys = map[key] || [key];
    for (var i = 0; i < keys.length; i++) {
      if (data[keys[i]] !== undefined && data[keys[i]] !== null) return data[keys[i]];
    }
    return null;
  };

  var Part = function(props) {
    var val = getValue(props.partKey);
    var color = getPaintColor(val);
    var bg = getPaintBg(val);
    return (
      <g>
        <rect x={props.x} y={props.y} width={props.w} height={props.h} rx={props.rx || 0} fill={bg} stroke={color} strokeWidth="1.5" />
        <text x={props.x + props.w / 2} y={props.y + props.h / 2 - 6} textAnchor="middle" fontSize="9" fill="#888" fontWeight="500">{props.label}</text>
        <text x={props.x + props.w / 2} y={props.y + props.h / 2 + 9} textAnchor="middle" fontSize="14" fill={color} fontWeight="700">{val || '-'}</text>
      </g>
    );
  };

  // 레이아웃: viewBox 260x420
  // 차체 가로 150 (x:55~205), 좌우문 각 25
  // 본넷 y:30~110, 루프 y:115~275, 트렁크 y:280~360
  // 좌펜더/문 x:25~52, 우펜더/문 x:208~235

  return (
    <div>
      <svg viewBox="0 0 260 410" width={width} style={{ display: 'block', margin: '0 auto' }}>

        {/* 방향 */}
        <text x="130" y="14" textAnchor="middle" fontSize="10" fill="#bbb">▲ 전면</text>
        <text x="130" y="405" textAnchor="middle" fontSize="10" fill="#bbb">▼ 후면</text>

        {/* 차량 외곽선 - 세단 상면 */}
        <path d="M75 30 L185 30 Q210 30 215 55 L215 340 Q215 365 185 365 L75 365 Q50 365 45 340 L45 55 Q45 30 75 30 Z"
          fill="none" stroke="#ccc" strokeWidth="1.2" />

        {/* 앞유리 (점선) */}
        <path d="M65 108 L195 108 L200 80 Q195 60 185 45 L75 45 Q65 60 58 80 Z"
          fill="none" stroke="#ddd" strokeWidth="0.7" strokeDasharray="4 3" />
        {/* 뒷유리 (점선) */}
        <path d="M65 282 L195 282 L200 310 Q195 335 185 350 L75 350 Q65 335 58 310 Z"
          fill="none" stroke="#ddd" strokeWidth="0.7" strokeDasharray="4 3" />

        {/* ── 본넷 ── */}
        <Part partKey="hood" label="본넷" x={65} y={38} w={130} h={68} rx={8} />

        {/* ── 루프 ── */}
        <Part partKey="roof" label="루프" x={65} y={112} w={130} h={166} rx={0} />

        {/* ── 트렁크 ── */}
        <Part partKey="trunk" label="트렁크" x={65} y={284} w={130} h={68} rx={8} />

        {/* ── 좌앞펜더 ── */}
        <Part partKey="fenderL" label="좌펜더" x={28} y={38} w={34} h={68} rx={4} />
        {/* ── 우앞펜더 ── */}
        <Part partKey="fenderR" label="우펜더" x={198} y={38} w={34} h={68} rx={4} />

        {/* ── 좌앞문 ── */}
        <Part partKey="doorFL" label="좌앞문" x={28} y={112} w={34} h={80} rx={0} />
        {/* ── 우앞문 ── */}
        <Part partKey="doorFR" label="우앞문" x={198} y={112} w={34} h={80} rx={0} />

        {/* ── 좌뒷문 ── */}
        <Part partKey="doorRL" label="좌뒷문" x={28} y={198} w={34} h={80} rx={0} />
        {/* ── 우뒷문 ── */}
        <Part partKey="doorRR" label="우뒷문" x={198} y={198} w={34} h={80} rx={0} />

        {/* ── 좌뒤펜더(쿼터) ── */}
        <Part partKey="quarterL" label="좌뒤펜" x={28} y={284} w={34} h={68} rx={4} />
        {/* ── 우뒤펜더(쿼터) ── */}
        <Part partKey="quarterR" label="우뒤펜" x={198} y={284} w={34} h={68} rx={4} />

        {/* 타이어 */}
        <rect x="22" y="55" width="10" height="30" rx="4" fill="#ddd" opacity="0.5" />
        <rect x="228" y="55" width="10" height="30" rx="4" fill="#ddd" opacity="0.5" />
        <rect x="22" y="300" width="10" height="30" rx="4" fill="#ddd" opacity="0.5" />
        <rect x="228" y="300" width="10" height="30" rx="4" fill="#ddd" opacity="0.5" />

        {/* 헤드라이트 */}
        <rect x="72" y="32" width="20" height="6" rx="3" fill="none" stroke="#ddd" strokeWidth="0.7" />
        <rect x="168" y="32" width="20" height="6" rx="3" fill="none" stroke="#ddd" strokeWidth="0.7" />
        {/* 테일라이트 */}
        <rect x="72" y="356" width="20" height="6" rx="3" fill="none" stroke="#ddd" strokeWidth="0.7" />
        <rect x="168" y="356" width="20" height="6" rx="3" fill="none" stroke="#ddd" strokeWidth="0.7" />

        {/* 사이드미러 */}
        <ellipse cx="28" cy="115" rx="6" ry="4" fill="none" stroke="#ddd" strokeWidth="0.7" />
        <ellipse cx="232" cy="115" rx="6" ry="4" fill="none" stroke="#ddd" strokeWidth="0.7" />

      </svg>

      {/* 범례 */}
      <div style={{ display: 'flex', justifyContent: 'center', gap: 14, marginTop: 8 }}>
        {[
          { color: '#1D9E75', bg: '#E1F5EE', label: '~150 정상' },
          { color: '#EF9F27', bg: '#FAEEDA', label: '150~250 도장' },
          { color: '#E24B4A', bg: '#FCEBEB', label: '250+ 판금' },
        ].map(function(l) {
          return (
            <span key={l.label} style={{ fontSize: 11, display: 'flex', alignItems: 'center', gap: 4 }}>
              <span style={{ width: 10, height: 10, borderRadius: 3, background: l.bg, border: '1.5px solid ' + l.color, display: 'inline-block' }} />
              <span style={{ color: '#666' }}>{l.label}</span>
            </span>
          );
        })}
      </div>
    </div>
  );
}
